/* eslint-disable react-hooks/exhaustive-deps */
import { Card, TBody, TD, TH, THead, TR, Table } from '@sede-enterprise/shell-ds-react-framework'
import React, { useContext, useEffect, useState } from 'react'
import { UnitContext } from '../../../App';
import { DEFAULT_METRIC_SPEC, INTERVAL_OPTIONS } from '../../../util/constants';
import { calculateStatistics, generateAnalysisSummary } from '../util/analysisUtils';
import useUpdateChart from '../../../util/hooks/useUpdateChart';
import useFetchCmlData from '../hooks/useFetchCmlData';
import { generateMetricData } from '../util/generateMetricData';
import { useMetricChartHook } from '../../../components/MetricChart/useMetricChartHook';
import MetricChart from '../../../components/MetricChart/MetricChart';
import useFetchSensorData from '../hooks/useFetchSensorData';

const AnalysisChart = ({ passedSubjects, passedFeature }) => {

    const context = useContext(UnitContext);
    const [cmlIDs, setCmlIDs] = useState([]);
    const [sensorIDs, setSensorIDs] = useState([]);
    const [analysisStatistics, setAnalysisStatistics] = useState([]);

    const {
        loading,
        start,
        setStart,
        end,
        setEnd,
        interval,
        setSelectedInterval,
        setRequestParams,
        formDirty,
    } = useMetricChartHook(DEFAULT_METRIC_SPEC);

    useEffect(() => {
        console.log(passedSubjects)
        // Set Sensor IDs required for BON sensors
        const cmlSubjects = passedSubjects.filter((x) => x.type === "Condition Monitoring Location");
        if(cmlSubjects.length === 0){
            setSensorIDs(passedSubjects.filter((x) => x.type === "Sensor" ).map((x) => x.name));
        }else{
            setSensorIDs([]);
        }
        setCmlIDs(passedSubjects.filter((x) => x.type === "Condition Monitoring Location").map((x) => x.name));
    }, [passedSubjects]);

    const { sensorData, sensorDataLoading } = useFetchSensorData({ sensorIDs, start, end, interval, passedFeature, context });
    const { cmlData, cmlDataLoading } = useFetchCmlData({ cmlIDs, start, end, interval, passedFeature, context });

    const metricData = generateMetricData(
        sensorIDs,
        cmlIDs,
        passedFeature,
        sensorData,
        cmlData,
        context,
        passedSubjects
    );


    const updateChart = useUpdateChart({
        setRequestParams,
        start,
        end,
        interval,
    });

    useEffect(() => {
        setAnalysisStatistics(calculateStatistics(sensorData, cmlData, context.units, passedFeature, passedSubjects));
    }, [cmlData, sensorData]);

    const plotLoading = cmlDataLoading || sensorDataLoading;

    const analyisSummary = generateAnalysisSummary(analysisStatistics, context, metricData);

    const showAnalysisData = (
        <MetricChart
            yaxes={{
                yaxis: { fixedrange: false, side: "left" },
                yaxis2: {
                    fixedrange: false,
                    side: "right",
                    overlaying: "y",
                    anchor: "x",
                },
            }}
            data={metricData}
            metricData={metricData}
            loading={loading || plotLoading}
            start={start}
            setStart={setStart}
            end={end}
            setEnd={setEnd}
            interval={interval}
            setSelectedInterval={setSelectedInterval}
            intervalOpts={INTERVAL_OPTIONS}
            formDirty={formDirty}
            onSubmit={updateChart}
            noLegends={true}
            plotLoading={plotLoading}
            isAnalysisData={true}
            analyisSummary={analyisSummary}
        />
    )

    return (
        <div className='parent-container' id='analysis-chart-id-1'>
            <div className='content-container' id='analysis-chart-id-2'>
                <div className='content-header' id='analysis-chart-id-3'>
                    <h2 id='analysis-chart-id-4'>Analysis Chart</h2>
                </div>
                <Card className='chart-card' bodyPadding={false} id='analysis-chart-id-5'>
                    <div className='analysis-graphs-container' id='analysis-chart-id-6'>
                        {metricData.length > 0 ? showAnalysisData : null}
                    </div>
                    <div className='statistics-container' id='analysis-chart-id-7'>
                        {/* {plotLoading && <div className='loading-container'> <Loading /> </div>} */}
                        {!plotLoading && analysisStatistics.length > 0 && <Table style={{ width: "100%" }} id='analysis-chart-id-8'>
                            <THead id='analysis-chart-id-9'>
                                <TR id='analysis-chart-id-10'>
                                    <TH id='analysis-chart-id-11'></TH>
                                    <TH id='analysis-chart-id-12'>Type</TH>
                                    <TH id='analysis-chart-id-13'>Name</TH>
                                    <TH id='analysis-chart-id-14'>Feature</TH>
                                    <TH id='analysis-chart-id-15'>Average</TH>
                                    <TH id='analysis-chart-id-16'>Standard Deviation</TH>
                                    <TH id='analysis-chart-id-17'>Standard Error</TH>
                                    <TH id='analysis-chart-id-18'>Median</TH>
                                    <TH id='analysis-chart-id-19'>Min</TH>
                                    <TH id='analysis-chart-id-20'>Max</TH>
                                </TR>
                            </THead>
                            <TBody id='analysis-chart-id-21'>
                                {analyisSummary.map((statistic, index) => (
                                    <TR key={index} id='analysis-chart-id-22'>
                                        <TD id='analysis-chart-id-23'>
                                            <div
                                                className='stats-legend'
                                                style={{
                                                    height: '5px',
                                                    width: '40px',
                                                    backgroundColor: statistic.color,
                                                }}
                                                id='analysis-chart-id-24'
                                            ></div>
                                        </TD>
                                        <TD id='analysis-chart-id-25'>{statistic.type}</TD>
                                        <TD id='analysis-chart-id-26'>{statistic.name}</TD>
                                        <TD id='analysis-chart-id-27'>{statistic.feature}</TD>
                                        <TD id='analysis-chart-id-28'>{statistic.average}</TD>
                                        <TD id='analysis-chart-id-29'>{statistic.standardDeviation}</TD>
                                        <TD id='analysis-chart-id-30'>{statistic.standardError}</TD>
                                        <TD id='analysis-chart-id-31'>{statistic.median}</TD>
                                        <TD id='analysis-chart-id-32'>{statistic.min}</TD>
                                        <TD id='analysis-chart-id-33'>{statistic.max}</TD>
                                    </TR>
                                ))}
                            </TBody>
                        </Table>
                        }
                    </div>
                </Card>
            </div>
        </div>
    )
}

export default AnalysisChart